import { render, staticRenderFns } from "./SelfAssessmentAccelerationTest.vue?vue&type=template&id=73722353&scoped=true&"
import script from "./SelfAssessmentAccelerationTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentAccelerationTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentAccelerationTest.vue?vue&type=style&index=0&id=73722353&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73722353",
  null
  
)

export default component.exports